"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToArray = exports.isBrowser = exports.generateQueryFromRawString = exports.generateQueryString = void 0;
const qs_1 = require("qs");
function generateQueryString(obj) {
    return (0, qs_1.stringify)(obj, { encodeValuesOnly: true });
}
exports.generateQueryString = generateQueryString;
function generateQueryFromRawString(rawQuery) {
    return (0, qs_1.stringify)((0, qs_1.parse)(rawQuery), { encodeValuesOnly: true });
}
exports.generateQueryFromRawString = generateQueryFromRawString;
const isBrowser = () => typeof window !== 'undefined';
exports.isBrowser = isBrowser;
const stringToArray = (value) => {
    return value.split('.');
};
exports.stringToArray = stringToArray;
